module.exports = __webpack_public_path__ + "static/media/notWorking.95ff5037.svg";